import React, { useEffect } from "react";
import "./preview.scss";

const ImportPreview = ({
  onBack,
  data,
  onUploadSuccess,
  headerData,
  isLoading,
}) => {
  useEffect(() => {
    // Required headers definition
    const requiredHeaders = [
      "firstname",
      "lastname",
      "email",
      "role_id",
      "school",
      "class",
      "division",
    ];

    // Validation logic
    if (headerData) {
      const isEqual =
        requiredHeaders.length === headerData.length &&
        requiredHeaders.every((item, i) => item === headerData[i]);

      if (data && data.length > 0 && !isEqual) {
        // alert("Alert: The fields are not matching with the required format!");
      }
    }
  }, [data, headerData]);

  const emailCount = data?.reduce((acc, row) => {
    const email = row?.email?.toLowerCase()?.trim();
    if (email) {
      acc[email] = (acc[email] || 0) + 1;
    }
    return acc;
  }, {});

  const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const nameRegex = /^[A-Za-z\s'-]+$/;

  const isValidName = (name) => {
    return name && nameRegex.test(name.trim());
  };

  // const isValidPhone = (phone) => {
  //   return /^[0-9]{10}$/.test(phone); // exactly 10 digits only
  // };

  return (
    <div className="import-preview-global-container">
      {/* Sticky Header with title left + action buttons right */}
      <div className="preview-header-sticky">
        <div className="preview-header-left">
          <h2 className="preview-main-title">Upload Users Preview</h2>
          <span className="preview-user-count">
            {data?.length || 0} users found
          </span>
        </div>
        <div className="preview-header-actions">
          <button
            className="btn-primary-upload"
            onClick={onUploadSuccess}
            disabled={isLoading}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
              <polyline points="17 8 12 3 7 8" />
              <line x1="12" y1="3" x2="12" y2="15" />
            </svg>
            Upload Users
          </button>
          <button className="btn-cancel" onClick={onBack} disabled={isLoading}>
            Cancel
          </button>
        </div>
      </div>

      {/* Scrollable Table Body */}
      <div className="preview-scrollable-body">
        <div className="table-card">
          <div className="table-responsive">
            <table className="moodle-styled-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>First Name</th>
                  <th>Last Name</th>
                  <th>Email</th>
                  <th>Class</th>
                  <th>Division</th>
                  <th>School</th>
                  {/* <th>Password</th> */}
                  <th>Role</th>
                </tr>
              </thead>
              <tbody>
                {data && data.length > 0 ? (
                  data.map((row, index) => (
                    <tr key={index}>
                      <td className="row-index">{index + 1}</td>
                      {/* <td>
                        {row?.firstname ? (
                          row?.firstname
                        ) : (
                          <span className="err-required">
                            required *
                          </span>
                        )}
                      </td>
                      <td>
                        {row?.lastname ? (
                          row?.lastname
                        ) : (
                          <span className="err-required">
                            required *
                          </span>
                        )}
                      </td> */}
                      <td>
                        {isValidName(row?.firstname) ? (
                          row.firstname
                        ) : (
                          <span className="err-required">
                            {row?.firstname
                              ? "Invalid first name"
                              : "required *"}
                          </span>
                        )}
                      </td>

                      <td>
                        {isValidName(row?.lastname) ? (
                          row.lastname
                        ) : (
                          <span className="err-required">
                            {row?.lastname ? "Invalid last name" : "required *"}
                          </span>
                        )}
                      </td>
                      <td className="email-cell">
                        {row?.email ? (
                          emailCount[row.email.toLowerCase().trim()] > 1 ? (
                            <div>
                              <div>{row.email}</div>
                              <div className="err-required">
                                duplicate email
                              </div>
                            </div>
                          ) : isValidEmail(row.email) ? (
                            row.email
                          ) : (
                            <div>
                              <div>{row.email}</div>
                              <div className="err-required">invalid email</div>
                            </div>
                          )
                        ) : (
                          <span className="err-required">required *</span>
                        )}
                      </td>
                      <td>
                        <span className="class-badge">{row?.class}</span>
                      </td>
                      <td>
                        <span className="division-badge">{row?.division}</span>
                      </td>
                      <td>{row?.school}</td>
                         {/* <td>
                        <span className="division-badge">{row?.reset_password}</span>
                      </td> */}
                      {/* <td>
                        {row?.phone ? (
                          isValidPhone(row.phone) ? (
                            row.phone
                          ) : (
                            <span style={{ color: "red",  fontSize: "12px" }}>invalid *</span>
                          )
                        ) : (
                          <span style={{ color: "red",  fontSize: "12px" }}>required *</span>
                        )}
                      </td> */}
                      <td
                        className={`role-badge role-${row?.role_name?.toLowerCase() === "student" ? "student" : +row?.role_name?.toLowerCase() === "teacher" ? "teacher" : row?.role_name?.toLowerCase() === "admin" ? "admin" : "student"}`}
                      >
                        {row?.role_name?.toLowerCase() === "student"
                          ? "student"
                          : row?.role_name?.toLowerCase() === "teacher"
                            ? "teacher"
                            : row?.role_name?.toLowerCase() === "admin"
                              ? "admin"
                              : "student"}
                        {/* {row?.role_name} */}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" style={{ textAlign: "center" }}>
                      No data found in the file.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImportPreview;
